export default "__VITE_ASSET__DMva3eWk__"